module.exports = "<div>\n    <button class=\"mirror-console-button mirror-console-run\">{run_console}</button>\n</div>"